import { buildRouteUrl } from '@/mixins/util';

/** Initial delay before Payment Details polling starts on /payment-status. */
export const PAYMENT_STATUS_INITIAL_DELAY_MS = 3500;

/** Payment Details poll interval. */
export const PAYMENT_DETAILS_POLL_INTERVAL_MS = 1000;

/** Payment Details / Payment URL poll timeout (matches progress bar duration). */
export const PAYMENT_DETAILS_POLL_TIMEOUT_MS = 3 * 60 * 1000;

export const PAYMENT_DETAILS_STAGE = 'Payment Details';
export const PAYMENT_URL_STAGE = 'Payment URL';

export const PAYMENT_STATUS_PATH = '/payment-status';
export const DIY_CHECK_PATH = '/confirm-payment-diy';
export const PROPOSAL_SUBMISSION_PATH = '/proposal-submission';

/** Legacy paths kept as thin redirects to /payment-status?outcome=… */
export const PAYMENT_FAILURE_PATH = '/paymentfailed';
export const PAYMENT_SUCCESS_LEGACY_PATH = '/payment';
export const INSPECTION_LEGACY_PATH = '/inspection';
export const REQUIREMENTS_LEGACY_PATH = '/pending';

/** Query + session key for terminal payment-status outcome. */
export const PAYMENT_STATUS_OUTCOME_QUERY_KEY = 'outcome';
export const PAYMENT_STATUS_OUTCOME_STORAGE_KEY = 'payment_status_outcome';
export const PAYMENT_STATUS_OUTCOME_SUCCESS = 'success';
export const PAYMENT_STATUS_OUTCOME_FAILURE = 'failure';
export const PAYMENT_STATUS_OUTCOME_PENDING = 'pending';
export const PAYMENT_STATUS_OUTCOME_INSPECTION = 'inspection';
export const PAYMENT_STATUS_OUTCOME_REQUIREMENTS = 'requirements';

/** Session key for proposal-submit / payment-URL errors shown on the DIY review page. */
export const DIY_PROPOSAL_ERROR_STORAGE_KEY = 'diy_proposal_error';

/** Session key for insurer payment gateway URL (JSON-stringified). */
export const PAYMENT_URL_STORAGE_KEY = 'payment_url';

export const PAYMENT_GATEWAY_FALLBACK_MESSAGE =
  'We are facing some issue while redirecting to Payment Gateway.';

/** Session flag set before navigating to insurer payment gateway (same-tab). */
export const PAYMENT_GATEWAY_REDIRECTED_STORAGE_KEY = 'payment_gateway_redirected';

export const PAYMENT_GATEWAY_BACK_MESSAGE =
  'You returned from the payment page. You can go back to proposal review to continue.';

export const DIY_INLINE_ERROR_TITLE = 'Something went wrong';
export const DIY_INLINE_ERROR_BUTTON_LABEL = 'Back to proposal review';

/** Pause on the proposal waiting page before opening the payment URL. */
export const PAYMENT_REDIRECT_PAUSE_MS = 3000;

export const PROPOSAL_SUBMITTING_TITLE = 'Your proposal is being submitted';
export const PROPOSAL_SUBMITTING_SUBTITLE =
  'Please do not refresh or close this window. We are sending your proposal to the insurer.';
export const PROPOSAL_SUBMITTING_HINT = 'This may take a few moments.';

export const PAYMENT_PENDING_TITLE = 'Payment Pending';
export const PAYMENT_PENDING_SUBTITLE =
  'Your payment status is still pending. Please do not refresh or close this window. You can check back shortly or contact support if this continues.';

/** Query params synced when showing Payment Pending after transport failures. */
export const PAYMENT_PENDING_QUERY_STATUS = 'pending';
export const PAYMENT_PENDING_QUERY_DESCRIPTION = 'Payment Pending at redirect';
export const PAYMENT_PENDING_QUERY_ACTION = 'payment';

/**
 * Absolute hash URL used as saveProposal redirect_url (PG return host).
 * Insurer appends referenceId & action=payment (health-style).
 */
export function buildPaymentStatusRedirectUrl() {
  return buildRouteUrl('payment-status');
}
